import { lazy } from 'react';
const MDExpenseReport = lazy(() => import('../pages/MDExpenseReport'));
const mdProgramProjextExpenseReportRoute = {
  public: [],
  auth: [
    {
      name: 'md_expense_report',
      path: '/finance-and-accounting/md-program-project-expense-report',
      component: MDExpenseReport,
    },
  ],
};
export default mdProgramProjextExpenseReportRoute;
